<template>
  <nav class="navbar navbar-fixed-top" role="navigation">

    <div class="navbar-header">
      <a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="#"><i class="fa fa-bars"></i></a>
    </div>

    <ul class="nav navbar-top-links navbar-right pull-right">
      <notifications v-if="$user.canSeeNotifications" />
      <li>
        <router-link :to="{ name: 'auth.logout' }" data-toggle="tooltip" data-placement="left" title="" data-original-title="Logout">
          <i class="fa fa-sign-out"></i>
        </router-link>
      </li>
    </ul>

  </nav>
</template>
<script>
  import Notifications from 'components/Notifications'

  export default {
    components: {
      Notifications
    }
  }
</script>



// WEBPACK FOOTER //
// TopBar.vue?c6c54e32